import { DinnerSuggestionSubject, UserAction } from "@app/types/GtmData"

import type { DinnerSuggestionsStep } from "./DinnerSuggestionsPopup.flow"

export const buildDinnerSuggestionsTrackingAction = (
    action: UserAction,
    subject: DinnerSuggestionSubject | string,
) => `${action} ${subject}`

export const getDinnerSuggestionsPrimaryTrackingAction = (
    step: DinnerSuggestionsStep,
    shouldShowConsentStep: boolean,
) => {
    switch (step) {
        case "intro":
            return buildDinnerSuggestionsTrackingAction(
                UserAction.ClickOn,
                DinnerSuggestionSubject.StartOnboarding,
            )
        case "moreOf":
            return buildDinnerSuggestionsTrackingAction(
                UserAction.ClickOn,
                DinnerSuggestionSubject.Next,
            )
        case "importantToMe":
            return buildDinnerSuggestionsTrackingAction(
                UserAction.ClickOn,
                shouldShowConsentStep
                    ? DinnerSuggestionSubject.NextStep
                    : DinnerSuggestionSubject.Finish,
            )
        case "consent":
            return buildDinnerSuggestionsTrackingAction(
                UserAction.ClickOn,
                DinnerSuggestionSubject.Finish,
            )
    }
}

export const getDinnerSuggestionsSecondaryTrackingAction = (step: DinnerSuggestionsStep) => {
    return buildDinnerSuggestionsTrackingAction(
        UserAction.ClickOn,
        step === "moreOf" || step === "importantToMe"
            ? DinnerSuggestionSubject.Skip
            : DinnerSuggestionSubject.Close,
    )
}
